var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"padding-top":"20px","padding-left":"15%"}},[_c('div',{staticStyle:{"width":"70%"}},[_c('v-breadcrumbs',{attrs:{"divider":">","items":_vm.items}}),_c('FormTextInput')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }